
import React, { useMemo } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Badge,
} from "reactstrap";

const CleaningQueue = ({
  rooms = [],
  tasks = [],
}) => {

  const getPriorityScore = (
    room,
    task
  ) => {
    if (
      room.isVipRoom &&
      room.housekeepingStatus ===
        "DIRTY"
    )
      return 1;

    if (
      room.isVipRoom &&
      room.housekeepingStatus ===
        "INSPECTION"
    )
      return 2;

    if (
      room.housekeepingStatus ===
      "DIRTY"
    )
      return 3;

    if (
      room.housekeepingStatus ===
      "INSPECTION"
    )
      return 4;

    if (
      task?.taskType ===
      "MAINTENANCE"
    )
      return 5;

    return 99;
  };

  const queue = useMemo(() => {
    const items = rooms
      .map((room) => {
        const task =
          tasks.find(
            (t) =>
              t.roomId ===
                room._id ||
              t.roomId?._id ===
                room._id
          );

        return {
          room,
          task,
          score:
            getPriorityScore(
              room,
              task
            ),
        };
      })
      .filter(
        (item) =>
          item.score < 99
      )
      .sort(
        (a, b) =>
          a.score - b.score
      );

    return items;
  }, [rooms, tasks]);

  const getPriorityBadge =
    (room, task) => {
      if (
        room.isVipRoom &&
        room.housekeepingStatus ===
          "DIRTY"
      ) {
        return {
          text: "VIP",
          color: "danger",
        };
      }

      if (
        task?.priority ===
        "HIGH"
      ) {
        return {
          text: "HIGH",
          color: "warning",
        };
      }

      if (
        task?.priority ===
        "VIP"
      ) {
        return {
          text: "VIP",
          color: "danger",
        };
      }

      return {
        text: "NORMAL",
        color: "primary",
      };
    };

  const getStatusColor = (
    status
  ) => {
    switch (
      (status || "").toUpperCase()
    ) {
      case "DIRTY":
        return "danger";

      case "CLEAN":
        return "success";

      case "INSPECTION":
        return "info";

      case "CLEANING":
        return "warning";

      default:
        return "secondary";
    }
  };

  return (
    <Card className="shadow-sm">
      <CardHeader className="fw-bold">
        Cleaning Queue
      </CardHeader>
      <CardBody>
        {queue.length === 0 ? (
          <div className="text-center text-muted">
            No pending rooms
          </div>
        ) : (
          queue.map(
            (
              {
                room,
                task,
              },
              index
            ) => {
              const priority =
                getPriorityBadge(
                  room,
                  task
                );

              return (
                <div
                  key={
                    room._id
                  }
                  className="border rounded p-2 mb-3"
                >
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <div className="fw-bold">
                        Room{" "}
                        {
                          room.roomNumber
                        }
                      </div>
                      <small className="text-muted">
                        {
                          room
                            .roomType
                            ?.name
                        }
                      </small>
                    </div>

                    <div className="text-end">

                      <Badge
                        color={
                          priority.color
                        }
                        className="mb-1"
                      >
                        {
                          priority.text
                        }
                      </Badge>

                      <br />

                      <Badge
                        color={getStatusColor(
                          room.housekeepingStatus
                        )}
                      >
                        {
                          room.housekeepingStatus
                        }
                      </Badge>

                    </div>

                  </div>

                  <div className="mt-2">

                    <small className="text-muted">
                      Queue Position
                    </small>

                    <div>
                      #
                      {index + 1}
                    </div>

                  </div>

                  {task && (
                    <>
                      <div className="mt-2">

                        <small className="text-muted">
                          Task
                        </small>

                        <div>
                          {
                            task.taskType
                          }
                        </div>

                      </div>

                      <div className="mt-2">

                        <small className="text-muted">
                          Assigned To
                        </small>

                        <div>
                          {task.assignedToName ||
                            "-"}
                        </div>

                      </div>

                      <div className="mt-2">

                        <small className="text-muted">
                          Task Status
                        </small>

                        <div>
                          {
                            task.status
                          }
                        </div>

                      </div>
                    </>
                  )}

                  <div className="mt-2">

                    <small className="text-muted">
                      Building
                    </small>

                    <div>
                      {
                        room.building
                      }{" "}
                      / Floor{" "}
                      {
                        room.floor
                      }
                    </div>

                  </div>

                </div>
              );
            }
          )
        )}

      </CardBody>
    </Card>
  );
};

export default CleaningQueue;